import * as actionTypes from '../actions/actionTypes';

export default function currencyInfoReducer(state = [], action) {
  switch(action.type){
    case actionTypes.SET_CURRENCY_INFO: {
      return action.currencyInfo;
    }
    case actionTypes.RESET_CURRENCYINFO_DROPDOWN: {
      return [];
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/currencyInfoReducer.js